// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1QJDd","header":"ReportDetails_header__1_YWM","title":"ReportDetails_title__3G1ri","left":"ReportDetails_left__2yPQ-"};